interface Props {
  color: string;
  size?: number;
}

export default function TeamIcon({ color, size = 16 }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
      <path
        d="M8 1.4 L14.2 5 V11 L8 14.6 L1.8 11 V5 Z"
        fill={color}
        stroke={color}
        strokeLinejoin="round"
        strokeWidth="0.6"
      />
    </svg>
  );
}
